import React, { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";

const TransitionContext = createContext();

export const useTransitionCursor = () => useContext(TransitionContext);

export const TransitionProvider = ({ children }) => {
    const navigate = useNavigate();
    return (
        <TransitionContext.Provider value={{ transitionTo: navigate }}>
            {children}
        </TransitionContext.Provider>
    );
};
